import React from "react";

import Form from "@Components/Form";
import { URLS, HARI_TERABAI_DAY_URL } from "configs/constants";

const today = new Date();

const initialValues = {
  name: "",
  date:
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate(),
  estate: "",
  division: "",
  block: "",
  type_of_attendance_present: 20005,
};

const HariTerabaiViewDetails = () => {
  const formFields = [
    {
      type: "renderonly",
      name: "date",
      key: "date",
      label: "Date",
    },
    {
      type: "renderonly",
      name: "estate_name",
      key: "estate_name",
      label: "Estate",
    },
    {
      type: "renderonly",
      name: "division_name",
      key: "division_name",
      label: "Division",
    },
    {
      type: "renderonly",
      name: "block_name",
      key: "block_name",
      label: "Block",
    },
    {
      type: "renderonly",
      name: "type_of_attendance_present_name",
      key: "type_of_attendance_present_name",
      label: "Type of Attendance (Present)",
    },
  ];

  const formButtons = ["cancel"];

  return (
    <div>
      <Form
        initialValues={initialValues}
        submitUrl={HARI_TERABAI_DAY_URL}
        listRoute={URLS.NON_WORKING_DAY_HARI_TERABAI}
        formFields={formFields}
        formButtons={formButtons}
        formTitle="Hari Terabai"
      />
    </div>
  );
};

export default HariTerabaiViewDetails;
